import {
    ConnectParams,
    ProviderConfig,
    TelephonyProvider,
} from "@/features/telephony/interfaces/telephony-provider.interface";
import { CallFailureType } from "@/types/call.types";

export class VonageAdapter implements TelephonyProvider {
    readonly id = "vonage" as const;
    initialized = false;

    subscribe(): () => void {
        return () => undefined;
    }

    async initialize(_config: ProviderConfig): Promise<void> {
        void _config;
        throw new Error(
            "VonageAdapter is not implemented yet. Register a Vonage adapter in infrastructure/telephony/vonage/"
        );
    }

    async connect(_params: ConnectParams): Promise<string> {
        void _params;
        throw new Error("VonageAdapter is not implemented yet.");
    }

    async disconnect(): Promise<void> {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    async mute(): Promise<boolean> {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    isMuted(): boolean {
        return false;
    }

    sendDigits(): void {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    async setInputDevice(): Promise<void> {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    async setOutputDevice(): Promise<void> {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    async releaseMicrophoneAccess(): Promise<void> {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    setOutgoingCallMelodyMuted(): void {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    async setEchoCancellation(): Promise<void> {
        throw new Error("VonageAdapter is not implemented yet.");
    }

    startAudioLevelMonitoring(): null {
        return null;
    }

    parseProviderStatus(): "disconnected" {
        return "disconnected";
    }

    mapFailureType() {
        return CallFailureType.GENERIC;
    }

    async destroy(): Promise<void> {
        this.initialized = false;
    }
}
